import styled from 'styled-components';

export default styled.div`
  text-align: center;
  justify-self: center;
  align-self: center;
  font-weight: normal;
`;
